import { Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { FuncaoParticipante, GrupoAcesso, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { Button, LgSpace, MdSpace } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, RouteComponentProps } from 'react-router-dom';
import { RootState } from 'store';
import ComprasVendas from './comprasVendas';
import Interoperabilidade from './interoperabilidade';
import OfertasPrimarias from './ofertasPrimarias';
import Transferencias from './transferencias';

import ComprasVendasCompromissadas from './comprasVendasCompromissadas';

type ComponentParams = { filtro?: string };
type ComponentState = { initialTab?: number };
type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const OperacoesLista: React.FC<Props> = (props) => {
  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [filtros, setFiltros] = useState<string>();

  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isParticipanteEscriturador =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const history = useHistory();

  useEffect(() => {
    if (props.match.params.filtro) {
      setFiltros(props.match.params.filtro);
    }
  }, []);

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Movimentações'}</Typography>
        {(isParticipanteCustodiante || isUsuarioOperacoes) && !isUsuarioLeitura && (
          <Button variant="contained" color="primary" onClick={() => history.push(`/operacoes/gerenciar/cadastro`)}>
            {'Nova Movimentação'}
          </Button>
        )}
      </Grid>
      <MdSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Ofertas Primárias" value={0} />
          <Tab label="Compras e Vendas" value={1} />
          <Tab label="Operações Compromissadas" value={2} />
          {!isParticipanteEscriturador && <Tab label="Interoperabilidade" value={3} />}
          {!isParticipanteEscriturador && <Tab label="Transferências" value={4} />}

        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <OfertasPrimarias filtros={filtros} />}
      {tabValue === 1 && <ComprasVendas />}
      {tabValue === 2 && <ComprasVendasCompromissadas />}
      {tabValue === 3 && !isParticipanteEscriturador && <Interoperabilidade />}
      {tabValue === 4 && !isParticipanteEscriturador && <Transferencias />}

      <LgSpace />
    </div>
  );
};

export default OperacoesLista;
